(() => {
 

  const CONFIG = {
    whiteGlove: {
      triggerProductIds: [
        '',
      ],
      marketMap: {
        canada: {
          marketId: '26291273846',
          addonVariantId: '43186427887734',
          price: '1299 CAD',
        },
        us: {
          marketId: '591560822',
          addonVariantId: '43186427887734',
          price: '$899',
        },
      },
    },

    warrantyUpgrade: {
      variantMap: {
        "43136662405238": {
          upgradedVariantId: "43136662438006",
          monthlyPrice: "$85"
        },
        "43037556113526": {
          upgradedVariantId: "43037556146294",
          monthlyPrice: "$42"
        },
        "43038869848182": {
          upgradedVariantId: "43038869880950",
          monthlyPrice: "$42"
        },
        "42953763651702": {
          upgradedVariantId: "42938953564278",
          monthlyPrice: "$42"
        },
        "42971165327478": {
          upgradedVariantId: "42892059115638",
          monthlyPrice: "$42"
        },
        "43038582079606": {
          upgradedVariantId: "42971254063222",
          monthlyPrice: "$107"
        },
        "43052827672694": {
          upgradedVariantId: "43052827705462",
          monthlyPrice: "$128"
        },
        "43056682106998": {
          upgradedVariantId: "43056682139766",
          monthlyPrice: "$298"
        },
        "43057101406326": {
          upgradedVariantId: "43057101439094",
          monthlyPrice: "$107"
        },
        "43057101406326": {
          upgradedVariantId: "43057101439094",
          monthlyPrice: "$107"
        },
        "43057375838326": {
          upgradedVariantId: "43057375871094",
          monthlyPrice: "$107"
        },
        
      },
    },

    redirectToCartAfterAdd: true,
  };

  let pendingCartAction = null;
  let submitting = false;

  function isUpsellTestMode() {
    const params = new URLSearchParams(window.location.search);

    if (params.get('upsellTest') === '1') {
        console.log('[Upsell] Test mode enabled');
        return true;
    }

    if (params.get('upsellTest') === '0') {
        console.log('[Upsell] Test mode disabled');
        return false;
    }

    return false;
  }
  function openModal(id) {
  const modal = document.getElementById(id);
  if (!modal) return;

  modal.setAttribute('aria-hidden', 'false');
  document.body.classList.add('upsell-modal-open');
}

function getCurrentMarketConfig() {
  const marketMap = CONFIG.whiteGlove.marketMap || {};

  const country = window.Shopify?.country?.toUpperCase?.() || '';
  const currency = window.Shopify?.currency?.active?.toUpperCase?.() || '';

  if (country === 'CA' || currency === 'CAD') {
    return marketMap.canada || null;
  }

  if (country === 'US' || currency === 'USD') {
    return marketMap.us || null;
  }

  return marketMap.us || null;
}

function closeModal(id) {
  const modal = document.getElementById(id);
  if (!modal) return;

  modal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('upsell-modal-open');
}

function closeAllModals() {
  closeModal('whiteGloveModal');
  closeModal('warrantyModal');
}

function getSelectedBundleItems(form) {
    const container = form.closest('product-info, .product, .product__info-wrapper') || document;
//  '.bundle-upgrade__checkbox:checked[data-variant-id], .product-addons__checkbox:checked[data-variant-id]'
//.bundle-upgrade__checkbox:checked[data-variant-id]
    return Array.from(
      container.querySelectorAll('.bundle-upgrade__checkbox:checked[data-variant-id], .product-addons__checkbox:checked[data-variant-id]')
    ).map((input) => ({
      id: Number(input.dataset.variantId),
      quantity: 1,
    })).filter((item) => Number.isFinite(item.id) && item.id > 0);
  }

  function getProductFormPayload(form) {
  const productId = form.querySelector('[name="product-id"]')?.value || null;
  const variantId = form.querySelector('[name="id"]')?.value || null;
  const quantityValue = form.querySelector('[name="quantity"]')?.value || '1';

  const quantity = Number.parseInt(quantityValue, 10);
  const bundleItems = getSelectedBundleItems(form);

  return {
    form,
    productId: productId ? String(productId) : null,
    variantId: variantId ? String(variantId) : null,
    quantity: Number.isNaN(quantity) || quantity < 1 ? 1 : quantity,
    bundleItems,
  };
}

function updateWhiteGloveModalContent(rule) {
  console.log({rule});
  const priceEls = document.querySelectorAll('.price-upsell-glove-modal');
  console.log(priceEls);
  if (!priceEls.length) return;

  priceEls.forEach((el) => {
    el.textContent = rule.price || '$899';
  });
}

  function resolveRule({ productId, variantId }) {
  const triggerProductIds = (CONFIG.whiteGlove.triggerProductIds || []).map(String);
  const currentMarket = getCurrentMarketConfig();

  if (
    productId &&
    currentMarket?.addonVariantId &&
    triggerProductIds.includes(String(productId))
  ) {
    return {
      type: 'white_glove',
      addonVariantId: String(currentMarket.addonVariantId),
      price: currentMarket.price || '$899',
    };
  }

  const upgradedVariantId = CONFIG.warrantyUpgrade.variantMap?.[String(variantId)];
  if (variantId && upgradedVariantId) {
    return {
      type: 'warranty_upgrade',
      upgradedVariantId: String(upgradedVariantId.upgradedVariantId),
      monthlyPrice: upgradedVariantId.monthlyPrice || '$XX',
    };
  }

  return null;
}

  async function addItemsToCart(items) {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ items }),
    });

    if (!response.ok) {
      let error = {};
      try {
        error = await response.json();
      } catch (_) {}
      throw error;
    }

    return response.json();
  }

  async function handleWhiteGloveDecision(addWhiteGlove) {
  if (!pendingCartAction || pendingCartAction.rule.type !== 'white_glove') return;

  const { variantId, quantity, rule, bundleItems = [] } = pendingCartAction;

  const items = [
    { id: Number(variantId), quantity },
    ...bundleItems,
  ];

  if (addWhiteGlove) {
    items.push({
      id: Number(rule.addonVariantId),
      quantity,
    });
  }

  await finalizeAddToCart(items);
}

  

  async function handleWarrantyDecision(upgrade) {
  if (!pendingCartAction || pendingCartAction.rule.type !== 'warranty_upgrade') return;

  const { variantId, quantity, rule, bundleItems = [] } = pendingCartAction;

  const finalVariantId = upgrade ? rule.upgradedVariantId : variantId;

  const items = [
    {
      id: Number(finalVariantId),
      quantity,
    },
    ...bundleItems,
  ];

  await finalizeAddToCart(items);
}

  async function finalizeAddToCart(items) {
    try {
      submitting = true;
      await addItemsToCart(items);

      pendingCartAction = null;
      closeAllModals();

      if (CONFIG.redirectToCartAfterAdd) {
        window.location.href = window.Shopify.routes.root + 'cart';
        return;
      }

      
      window.location.reload();
    } catch (error) {
      console.error('Upsell add-to-cart error:', error);
      pendingCartAction = null;
      closeAllModals();
      submitting = false;
    }
  }

  function updateWarrantyModalContent(rule) {
  const priceEl = document.querySelector('.js-warranty-monthly-price');
  if (!priceEl) return;

  priceEl.textContent = rule.monthlyPrice || '$XX';
}

  function onProductFormSubmit(event) {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    if (submitting) return;
    // SOLO PARA TEST
    //if (!isUpsellTestMode()) return;

    const payload = getProductFormPayload(form);
    if (!payload.productId || !payload.variantId) return;

    const rule = resolveRule(payload);
    if (!rule) return;

    event.preventDefault();
    event.stopPropagation();

    pendingCartAction = {
      ...payload,
      rule,
    };

    if (rule.type === 'white_glove') {
        updateWhiteGloveModalContent(rule);
      openModal('whiteGloveModal');
      return;
    }

    if (rule.type === 'warranty_upgrade') {
      updateWarrantyModalContent(rule);
      openModal('warrantyModal');
    }
  }

  function bindModalEvents() {
    document.addEventListener('click', async (event) => {
      const closeTarget = event.target.closest('[data-modal-close]');
      if (closeTarget) {
        const modalId = closeTarget.getAttribute('data-modal-close');
        closeModal(modalId);
        pendingCartAction = null;
        return;
      }

      if (event.target.id === 'whiteGloveYesBtn') {
        await handleWhiteGloveDecision(true);
        return;
      }

      if (event.target.id === 'whiteGloveNoBtn') {
        await handleWhiteGloveDecision(false);
        return;
      }

      if (event.target.id === 'warrantyYesBtn') {
        await handleWarrantyDecision(true);
        return;
      }

      if (event.target.id === 'warrantyNoBtn') {
        await handleWarrantyDecision(false);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeAllModals();
        pendingCartAction = null;
      }
    });
  }

  function init() {
    bindModalEvents();

    document.addEventListener('submit', onProductFormSubmit, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();